// Libs
import React, { ReactElement } from 'react';
import Image from 'next/image';
import { Icon, Typography } from 'ui-components';
// App
import styles from './content-card-main-image.module.scss';
import { ContentCardImageProps } from './content-card-main-image.interfaces';

const { NEXT_PUBLIC_APP_IMAGES_URL } = process.env;

/**
 * Image for content card
 * Designed to be used inside a content card
 * @param url the image url
 * @param alt the alt text for image
 */
const ContentCardMainImage = (props: ContentCardImageProps): ReactElement => {
  const { url, alt, id, showOverlay, overlayText } = props;

  return (
    <div className={styles.container}>
      {showOverlay && (
        <div className={styles.overlay}>
          <Typography variant="body2" align="center" className={styles.overlayTypography}>
            {overlayText}
          </Typography>
        </div>
      )}
      {(url && (
        <div className={styles.imageContainer}>
          <Image
            id={id}
            src={`${NEXT_PUBLIC_APP_IMAGES_URL}/${url}`}
            quality={100}
            style={{ objectFit: 'cover' }}
            layout="fill"
            alt={alt}
            className={styles.image}
          />
        </div>
      )) || (
        <div className={styles.image}>
          <Icon name="photo" className={styles.emptyImageIcon}></Icon>
        </div>
      )}
    </div>
  );
};

export default ContentCardMainImage;
